import { usePatientInsurancesQuery } from '@common/cache';
import { useState } from 'react';

export type PendingScreenSwitch = {
  tab: string;
};

export const useEditInsurance = (patient_id: string) => {
  const [isOpen, setIsOpen] = useState(false);
  const [tabIndex, setTabIndex] = useState('1');
  const [pendingSwitch, setPendingSwitch] =
    useState<PendingScreenSwitch | null>(null);

  const { data: patientInsurances } = usePatientInsurancesQuery({ patient_id });

  const hasMedicare = (patientInsurances?.primary_medicare.length ?? 0) > 0;
  const hasOther = (patientInsurances?.primary_other.length ?? 0) > 0;

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleForceClose = () => {
    setIsOpen(false);
    setTabIndex('1');
    setPendingSwitch(null);
  };

  const requestScreenSwitch = (newTab: string, isDirty: boolean) => {
    if (isDirty) {
      setPendingSwitch({ tab: newTab });
      return true;
    }
    setTabIndex(newTab);
    return false;
  };

  const confirmScreenSwitch = () => {
    if (!pendingSwitch) return;
    setTabIndex(pendingSwitch.tab);
    setPendingSwitch(null);
  };

  const cancelScreenSwitch = () => setPendingSwitch(null);

  const isMedicareFilled = hasMedicare;
  const isPrimaryOtherFilled = hasOther;
  const isSecondaryFilled = (patientInsurances?.secondary.length ?? 0) > 0;

  return {
    handleForceClose,
    handleOpen,
    isOpen,
    tabIndex,
    requestScreenSwitch,
    confirmScreenSwitch,
    cancelScreenSwitch,
    pendingSwitch,
    isMedicareFilled,
    isPrimaryOtherFilled,
    isSecondaryFilled,
  };
};
